<template>
    <div class="ponto-eletronico">
        <PageTitle icon="fa fa-calendar" main="Ponto eletrônico"
            sub="Ficha ponto \ Horas Programada x Realizada" />
        <div class="ponto-eletronico2">
            <b-card no-body>
                <b-tabs>                         
                    <b-tab title="Consulta Ficha ponto operador" active><PontoConsultaFichaPonto /></b-tab>
                    <b-tab title="Horas Programado x Realizado"><PontoProgrmadoRealizado /></b-tab>                                
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import PontoConsultaFichaPonto from '../flp_pontoeletronico/PontoConsultaFichaPonto'
import PontoProgrmadoRealizado from '../flp_pontoeletronico/PontoProgrmadoRealizado'
export default {
    name: 'PontoEletronicoPrincipal',    
    components: { PageTitle, PontoConsultaFichaPonto, PontoProgrmadoRealizado }
    
}
</script>

<style>

</style> 
